export default __webpack_public_path__ + "static/AppInterview1-7e4a32c9e67279d64d37b3a5bea842fe.png";